/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  updateShippingNotice(cart.total_price);
  window.shop.cart = cart; // Update global cart contents
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    console.log(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    ShopifyAPI.onCartUpdate(cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.cartQueue = [];

ShopifyAPI.processQueue = function() {
  // If there's something in the queue, process it
  if (ShopifyAPI.cartQueue.length) {
    var request = ShopifyAPI.cartQueue.shift();
    var requestType = request.type || 'add';
    
    ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
  }
  else {
    ShopifyAPI.getCart(ajaxCart.updateCart);
    if (typeof ShopifyAPI.afterQueue === "function") {
      ShopifyAPI.afterQueue();
    }
  }
};

ShopifyAPI.addItem = function(id, qty, properties, callback, requestType) {
  var params = {
    quantity: qty,
    id: id
  };
  var requestType = requestType || 'add';
  if(properties != false){
    params.properties = properties;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/' + requestType + '.js',
    dataType: 'json',
    data: params,
    success: function(cart){
      if(typeof callback === 'function'){
        callback();
      }
      ShopifyAPI.onCartUpdate(cart);
    },
    error: function(){}
  });
}

ShopifyAPI.updateItem = function(id, qty, properties, callback) {
  var params = {
    quantity: qty,
    id: id
  };
  if(properties != false){
    params.properties = properties;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: params,
    success: function(cart){
      if(typeof callback === 'function'){
        callback();
      }
      ShopifyAPI.onCartUpdate(cart);
    },
    error: function(){}
  });
}

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, triggerCartUpdate;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, relatedItemAddedCallback, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      if ($addToCart.length) {
        $addToCart.removeClass('is-added').addClass('is-adding loading');
      }
      $cartContainer.removeClass('is-added').addClass('is-adding loading');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      var $relatedItems = $('select[name="addRelated"] option:selected').first().add('input[name="addRelated"]');
      
      if ($relatedItems.length) {
        var timestamp = + new Date();
        if ($("#txtbox_name").length && $("#txtbox_name").val() != '') {
          $('input[name="properties[_relatedCartID]"]').val($('input[name="addRelated"]').data('name-number-variant') + '-' + timestamp);
        } else if ($("#txtbox_number").length && $("#txtbox_number").val() != '') {
          $('input[name="properties[_relatedCartID]"]').val($('input[name="addRelated"]').data('number-variant') + '-' + timestamp);
        }
        ShopifyAPI.addItemFromForm(evt.target, relatedItemAddedCallback, itemErrorCallback);
      } else {
        var $selectedVariant = $('.swatch-item input:checked').first();
        if ($selectedVariant.data('inventory-policy') != 'continue') {
          var pullParentInventory = $selectedVariant.data('inventory-from-parent');
          var selectedVariantId = $selectedVariant.val();

          if (pullParentInventory) {
            var parentInventory = parseInt($selectedVariant.data('inventory-max'));
            var addedInventory = parseInt($('#productQty input').val());
            var inventoryInCart = 0;

            for (var i = shop.cart.items.length - 1; i >= 0; i--) {
              if (shop.cart.items[i].variant_id == selectedVariantId || shop.cart.items[i].variant_id == pullParentInventory) {
                inventoryInCart = shop.cart.items[i].quantity;
              }
            }

            if ((inventoryInCart + addedInventory) > parentInventory) {
              $formContainer.after('<div class="errors qty-error">All available items in this size are in your cart.</div>');
              return;
            }

            var availableInvertory = parentInventory - inventoryInCart;
          }
        }

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        $selectedVariant.data('inventory', availableInvertory - addedInventory);
      }

    });
  };

  relatedItemAddedCallback = function(line_item, form) {
    var $relatedItems = $('select[name="addRelated"] option:selected').first().add('input[name="addRelated"]');
    $relatedItems.each(function(){
      var $this = $(this);
      selectedVariant = false;
      if ($("#txtbox_name").length && $("#txtbox_name").val() != '') {
        var selectedVariant = $this.data('name-number-variant');
      } else if ($("#txtbox_number").length && $("#txtbox_number").val() != '') {
        var selectedVariant = $this.data('number-variant');
      } else if ($this.val() != '') {
        var selectedVariant = $this.val();
      }
      if (selectedVariant) {
        var qty = $(this).data('quantity') || $('input[name="quantity"]').val();
        var lineitem = [{ variant_id: selectedVariant, quantity: qty }];
        if (line_item.properties !== null && line_item.properties.hasOwnProperty('_relatedCart')) {
          lineitem.properties = { "_relatedCartID": line_item.properties._relatedCartID }
        }
        
        ShopifyAPI.cartQueue.push.apply(ShopifyAPI.cartQueue, lineitem);
      }
    });

    ShopifyAPI.processQueue();

    itemAddedCallback(line_item);
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding loading').addClass('is-added');
    $cartContainer.removeClass('is-adding loading').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
    var $drawer = $('#CartDrawer');
    if (!$drawer.hasClass('open')) {
      $drawer.addClass('open');
      setTimeout(function() {
        $drawer.removeClass('open');
      }, 3000);
    }
  };
  
  triggerCartUpdate = function (response) {
    if (response['token']) {
      ShopifyAPI.getCart(cartUpdateCallback);
    } else {
      adjustCartCallback(response);
    }
  };

  var count = 1;
  $('.cartbutton a').mouseover( function() {
    
    if(count == 1){
      $cartContainer.addClass('is-updating loading');
      ShopifyAPI.getCart(cartUpdateCallback);
      count++;
    }

    // var $drawer = $('#CartDrawer');
    // if (!$drawer.hasClass('open')) {
    //   $drawer.fadeIn('fast', function() {
    //     $drawer.addClass('open');
    //   });
    //   $( "#CartContainer" ).fadeIn('fast');
    //   $( "#CartClose" ).fadeIn('fast');
    // }
  });

  // $('.cartbutton a').mouseleave(function() {
  //   var $drawer = $('#CartDrawer');
  //   $drawer.fadeOut('fast', function() {
  //     $drawer.removeClass('open');
  //   });
  // });

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding loading is-added');
    $cartContainer.removeClass('is-adding loading is-added is-updating');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);

    var isWholesaleCustomer = $('body').hasClass('customer-club--wholesale');
    
    if (isWholesaleCustomer && cart.total_price < 50000) {
      $('#postage-calculator p').html('$10.00'); 
      $('#total_price p').html(Shopify.formatMoney(1000.0 + cart.total_price, settings.moneyFormat));
    } else if (cart.total_price < 15000) {
      $('#postage-calculator p').html(Shopify.formatMoney(1000.0, settings.moneyFormat));
      $('#total_price p').html(Shopify.formatMoney(1000.0 + cart.total_price, settings.moneyFormat));
    } else {
      $('#postage-calculator p').html('$0.00');
      $('#total_price p').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
         
    if( isWholesaleCustomer) {
      $('[for="CartSpecialInstructions"]').hide();
	  $('[name="note"]').hide();
    } else {
      $('[for="CartSpecialInstructions"]').hide();
	  $('[name="note"]').hide();
    }
    
    if (cart.item_count > 0) {
      $('#checkoutBtn').css("display", "block");
      $('#CartCount').removeClass("hidden-count");
    } else {
      $('#checkoutBtn').css("display", "none");
      $('#CartCount').addClass("hidden-count");
    }
    $cartContainer.removeClass('loading');
  };
  
  $('.currency-on-desktop .currency-picker').change(function(){
    jQuery.getJSON('/cart.js', function(data) {

      cartUpdateCallback(data);
    
    });
  });

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    var hasGiftCard = false;
    var hasOtherProducts = false;
    // var disable_checkout = false;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      //if it is a customisation product
      var cust = true;
      if(cartItem.product_type == 'Customisation' || cartItem.product_type == 'Video Games' ) {
        cust = false;
      }
      
      var isGiftCard = true;
      if (cartItem.product_type == 'Gift Card'){
        hasGiftCard = true;
        isGiftCard = false;
      } else {
        hasOtherProducts = true;
      }
      
      var cartItemProperties = cartItem.properties;

      if (cartItemProperties) {
        if (cartItem.properties.hasOwnProperty('_relatedCartID')) {
          var cartRelatedID = cartItem.properties._relatedCartID;
        } else {
          var cartRelatedID = false;
        }

        if (cartItem.properties.hasOwnProperty('_inventorySource')) {
          var showQtySelector = false;
        } else {
          var showQtySelector = true;
        }

        // Remove hidden properties so they don't display in the cart
        for (var key in cartItemProperties) {
          if (cartItemProperties.hasOwnProperty(key)) {
            if (key.charAt(0) == '_') {
              delete cartItemProperties[key];
            }
          }
        }
      }

      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItemProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        singlePrice: cartItem.price,
        vendor: cartItem.vendor,
        displayProperties: cust,
        isCust: cust?false:true,
        isGift: isGiftCard,
        handle: cartItem.handle,
        key: cartItem.key,
        relatedID: cartRelatedID,
        showQtySelector: showQtySelector
      };

      items.push(item);
    });
    
    // Get the country
    // var country_code = 'nz';
    country_code = country_code ? country_code.toUpperCase() : 'AU';
  
    var shipping_rate = '';
    var new_rate = false;
  
    switch(country_code) {
      case 'US':
        shipping_rate = '20';
          new_rate = true;
          break;
      case 'NZ':
          shipping_rate = '20';
          new_rate = true;
          break;
        case 'UK':
          shipping_rate = '20';
          new_rate = true;
          break;
        case 'SG':
          shipping_rate = '20';
          new_rate = true;
          break;
        case 'FJ':
          shipping_rate = '20';
          new_rate = true;
          break;
      default:
          new_rate = false;
    }
    
    // console.log(disable_checkout);
    
    if(country_code == 'AU'){
      var isWholesaleCustomer = $('body').hasClass('customer-club--wholesale');
    
      if (isWholesaleCustomer) {
        shipping_rate = 1000.0;
      } else if (isWholesaleCustomer && cart.total_price > 50000){
      	shipping_rate = 0;
      } else if(cart.total_price < 15000 && !((hasGiftCard && !hasOtherProducts))) { 
        shipping_rate = 1000.0;
      } else {
        shipping_rate = 0;
      }
      
      $('body').removeClass('international-shipping');
      $('#freeShippingBanner').fadeIn('fast');
    } else {
      if(hasGiftCard && !hasOtherProducts) {
        shipping_rate = 0;
      } else {
        shipping_rate = 2000;
      }
      
      $('body').addClass('international-shipping');
      $('#freeShippingBanner').fadeOut('fast');
    }
   
    var discount_code = '';

    if ($.session != undefined && $.session.get('discount')) {
      discount_code = '/?discount=' + $.session.get('discount');
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      onlyGiftCard: (hasGiftCard && !hasOtherProducts) ? false : true,
      newRate: new_rate,
      countryCode: country_code,
      shippingRate: shipping_rate,
      discountCode: discount_code,
      totalInternationalPrice: Shopify.formatMoney(cart.total_price + shipping_rate, settings.moneyFormat)
    }
    
    if(hasGiftCard && !hasOtherProducts) {
      $('body').addClass("onlygiftcard");
    }

    $cartContainer.append(template(data));
    
    $cartContainer.removeClass('is-updating');

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
    
    // $('.currency-picker').trigger('change');

    $('.ajaxcart__product[data-handle="custom-printing"]').each(function(){
      var $this = $(this);
      var relatedLine = $this.data('related-id') || false;
      if (relatedLine) {
        var $relatedItem = $('[data-related-id="' + relatedLine + '"]').not(this);
        var titleString = $this.find('.ajaxcart__product-name').text();
        var priceString = $this.find('span.money').html();
        var appendString = '';
        appendString += '<span class="ajaxcart__product-meta text-right">';
        appendString += titleString;
        appendString += ': ';
        appendString += '<span class="related-product-price">' + priceString + '</span>';
        appendString += '</span>';
        $relatedItem.find('.ajaxcart__product-details > p').first().append(appendString);
        $relatedItem.find('.ajaxcart__qty').hide();
        $this.hide();
      }
    });
    
    var isWholesaleCustomer = $('body').hasClass('customer-club--wholesale');
    
    if (isWholesaleCustomer && cart.total_price < 50000) {
      $('#postage-calculator p').html('$10.00');
      $('#total_price p').html(Shopify.formatMoney(1000.0 + cart.total_price, settings.moneyFormat));
      $('#shipping-rate p').html('AU Wholesale Shipping');
    } 
    else if(isWholesaleCustomer && cart.total_price >= 50000){
        $('#postage-calculator p').html('$0.00');
      	$('#total_price p').html(Shopify.formatMoney(0 + cart.total_price, settings.moneyFormat));
        $('#shipping-rate p').html('FREE Wholesale Shipping');
    } 
    else if(cart.total_price < 15000){
      $('#postage-calculator p').html(Shopify.formatMoney(1000.0, settings.moneyFormat));
        $('#total_price p').html(Shopify.formatMoney(1000.0 + cart.total_price, settings.moneyFormat));
        $('#shipping-rate p').html('AU Priority Shipping');
    }  
    else {
        $('#postage-calculator p').html('$0.00');
        $('#shipping-rate p').html('FREE Priority Shipping');      
        $('#total_price p').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      }
    
    if(cart.item_count > 0){
      $('#checkoutBtn').css("display", "block");
    }else{
      $('#checkoutBtn').css("display", "none");
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          // qty = parseInt($qtySelector.val().replace(/\D/g, ''));
          qty = parseInt($qtySelector.val());

      var qty = validateQty(qty);
      var relatedQty = false;

      var $parent = $el.parents('.ajaxcart__product');
      var relatedItem = $parent.data('related-id');
      if (relatedItem) {
        var relatedQty = parseInt($('[data-related-id="' + relatedItem + '"]').data('qty'));
      }

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
        if (relatedQty) relatedQty += 1;
      } else {
        qty -= 1;
        if (relatedQty) relatedQty -= 1;

        if (qty <= 0) qty = 0;
        if (relatedQty <= 0) relatedQty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
      
      if (relatedItem) {
        var relatedLine = $('.ajaxcart__product[data-related-id="' + relatedItem + '"]').not($parent).find('.ajaxcart__row').data('line');
        updateQuantity(relatedLine, relatedQty);
      }

    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
    
    
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    updateCart: triggerCartUpdate
  };
  
  return module;

}(ajaxCart || {}, jQuery));